import { API_DATE_FORMAT } from '../../../../../../constants';
import { TREATMENT_SERVICE_PREFIXES } from '../../../../../../store/treatmentPlanV3';

import type { TreatmentFieldName, TreatmentFormValues } from '../types';

export function getTreatmentFieldCompareValue(
  name: TreatmentFieldName,
  values: TreatmentFormValues,
) {
  if (name === 'proposed_start_date') {
    return values.proposed_start_date?.format(API_DATE_FORMAT) ?? '';
  }
  return values[name];
}

export function getAssessmentHoursSiblingName(name: TreatmentFieldName) {
  if (name === 'assessment_97151_hours') return 'assessment_97152_hours';
  if (name === 'assessment_97152_hours') return 'assessment_97151_hours';
  return null;
}

export function getTreatmentServicePairedFieldNames(
  name: TreatmentFieldName,
): TreatmentFieldName[] {
  const prefix = TREATMENT_SERVICE_PREFIXES.find(
    (servicePrefix) => name === `${servicePrefix}_hours` || name === `${servicePrefix}_per`,
  );
  if (!prefix) return [];
  return name.endsWith('_hours') ? [`${prefix}_per`] : [`${prefix}_hours`];
}
